import { determineLogin } from '@/pages/api/scribeAPI';
import { useQuery } from '@tanstack/react-query';

export const DETERMINE_LOGIN_QUERY_KEY = 'DetermineLogin';

/**
 * Hook for calling Identity Broker determine-login API.
 * Returns vendor and screen_hint based on email domain/user profile.
 *
 * Uses `enabled: false` by default - call `refetch()` to trigger the query.
 */
export function useQueryDetermineLogin(email: string) {
  return useQuery({
    queryKey: [DETERMINE_LOGIN_QUERY_KEY, email],
    queryFn: async () => {
      const { data } = await determineLogin(email);
      console.log('useQueryDetermineLogin data', data);

      return data;
    },
    enabled: false,
    retry: false,
  });
}
